/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostListener, OnInit, TemplateRef, OnDestroy } from "@angular/core";
import { TranslationService } from "./shared/service/translation.service";
import { CommonModalService } from 'src/app/modules/events/services/common-modal.service';
import { Subscription } from "rxjs";
import { LanguageService } from "./shared/service/language.service";
import { AuthAmplifyService } from "./shared/service/auth-amplify.service";
import { NavigationEnd, Router } from "@angular/router";
import { StoreManagerService } from "./shared/store-manager/services/store-manager.service";
import { CrowdinOtaService } from "./shared/service/crowdin-ota/crowdin-ota.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "admin-console";
  translatedArray: any[] = [];
  language: string = 'en-GB';
  openModalFlag: boolean = false;
  public subscriptions: Subscription[] = [];
  public enableLeftPanelView: boolean = false;
  public refSessionComAvailable: boolean = false;
  routeToView: boolean = false;
  public showLanguageSelectionModal: boolean = false;
  public languageSelection!: TemplateRef<any> | null;
  public allSupportedLangCodes: any[] = [];


  isLoggedIn:boolean=true
  isProfileAvailable:any=localStorage.getItem('profile')
  @HostListener("window:popstate")
  async onBrowserBackBtnClose() {
    const dbs = await window.indexedDB.databases();
    dbs.forEach((db: any) => {
      window.indexedDB.deleteDatabase(db.name);
    });
  }

  constructor(private readonly translationService: TranslationService,
    private readonly commonModalService: CommonModalService, private readonly languageService: LanguageService,
    private readonly authAmplifyService: AuthAmplifyService,
    private readonly route: Router,
    private readonly _crowdinOtaService: CrowdinOtaService,
    private readonly _storeManagerService: StoreManagerService
  ) {
    this.initializeAllModules();
  }

  async ngOnInit() {
    this.languageService.showLanguageSelectionModal$.subscribe((data: boolean) => {
      this.showLanguageSelectionModal = data;
    });

    await this._crowdinOtaService.initializeLanguage();

    localStorage.setItem('isDealer', 'true');

    this.route.events.subscribe((events)=>{

      if(events instanceof NavigationEnd){
        if(localStorage.getItem('aliasGroupName') && !localStorage.getItem('profileName')){
          this.route.navigate(['profile'])
        }
      }
    })
    this.subscriptions.push(this.commonModalService.participantQrModalStream$.subscribe((data: boolean) => {
      if(data !== null || data !== undefined) {
        this.openModalFlag = data;
      }
    })
    );
  }

  public initializeAllModules(): void {
    const fullURL = window.location.href.split('/');
    this.allSupportedLangCodes = this.translationService.getSupportedLanguageByCode();
    if (this.allSupportedLangCodes.includes(fullURL[3])) {
      this._storeManagerService.setUserLanguageToStore(fullURL[3]);
    }
    const selectedLang = this.languageService.getLanguage();
    if (selectedLang) {
      this.language = selectedLang;
    } else {
      this.language = this.allSupportedLangCodes.find(lang => lang.includes('en')) ?? 'en-GB';
      this._storeManagerService.setUserLanguageToStore(fullURL[3]);
    }
    this.translationService.getBpConfigurations();
    const featureFlags = this.translationService.featureFlags;
    this.enableLeftPanelView = featureFlags?.locations.enableLeftPanelView;
    this.refSessionComAvailable = featureFlags?.profile.isRefSessionComAvailable;
  }


  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}